import React, { useState, useContext, useEffect } from 'react'

import useFetch from './useFetch'

export const API_ENDPOINT = `https://www.omdbapi.com/?apikey=${process.env.REACT_APP_MOVIE_DB_API_KEY}`
const AppContext = React.createContext()
// console.log(process.env.REACT_APP_MOVIE_DB_API_KEY)
const AppProvider = ({ children }) => {
    const [query, setQuery] = useState('Star wars')
    const { isLoading, error, data: movies } = useFetch(`&s=${query}`)

    return (
        <AppContext.Provider
            value={{ isLoading, error, movies, query, setQuery }}
        >
            {children}
        </AppContext.Provider>
    )
}
// make sure use
export const useGlobalContext = () => {
    return useContext(AppContext)
}

export { AppContext, AppProvider }
